class DrawerPromotions extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handlePromotion = this.handlePromotion.bind(this)
    this.handleClosePromotion = this.handleClosePromotion.bind(this)

    window.addEventListener('load', this.handlePromotion)
  }

  handlePromotion () {
    if (window.sessionStorage.getItem(this.shownPromotion) === 'true') {
      return
    }

    window.drawers.activeDrawerKey = 'drawer-promotion'

    this.externalEls.drawer.element.addEventListener('close', () => {
      this.handleClosePromotion()
    })
  }

  handleClosePromotion () {
    window.sessionStorage.setItem(this.shownPromotion, true)
  }

  get shownPromotion () {
    return 'BAO-promotion'
  }
}

if (!customElements.get('drawer-promotions')) {
  customElements.define('drawer-promotions', DrawerPromotions)
}
